import React from 'react'
import { Route } from 'react-router-dom'
import AsyncComponent from './async.component'

export const AppRoute = ({
	module: Module,
	layout: Layout,
	noPadding,
	adaptHeaderBG,
	...rest
}) => (
	<Route
		{...rest}
		component={() => {
			return Layout ? (
				<Layout noPadding={noPadding} adaptHeaderBG={adaptHeaderBG}>
					<AsyncComponent moduleProvider={Module} />
				</Layout>
			) : (
				<AsyncComponent moduleProvider={Module} />
			)
		}}
	/>
)
